import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { TooltipMenu, Icon, Button } from '@haldor/ui';
import { getActiveSchool } from 'helpers/localstorage';
import { onRouteBack } from 'actions/header';

import './Header.scss';

class Header extends Component {

	goBack = (event) => {
		event.preventDefault();
		if (this.props.settings.history.length > 1) {
			const newRoute = this.props.settings.history[1];
			this.props.onRouteBack();
			this.props.history.push(newRoute);
		} else {
			window.history.go(-1);
		}
	}

	renderAction = (action, index) => {
		switch (action.type) {
			case 'button':
				return (
					<Button key={'action-' + index} type={action.buttonType} disabled={action.disabled} onClick={action.onClick}>
						{action.icon != null ?
							<Icon name={action.icon} />
							: null}

						{action.value}
					</Button>
				);

			case 'dropDown':
				return (
					<TooltipMenu
						key={'action-' + index}
						trigger={
							<Button disabled={action.disabled}>
								{action.icon != null ? <Icon name={action.icon} /> : null}

								{action.value}
							</Button>
						}
					>
						{action.subButtons ?
							action.subButtons.map((subAction, index) => (
								<TooltipMenu.Item
									onClick={() => subAction.onClick(true)}
									key={'subAction-' + index}
								>
									{subAction.value}
								</TooltipMenu.Item>
							))
							: null}
					</TooltipMenu>
				);

			case 'icon':
				return (
					<Link to="#" key={'action-' + index} className="header-action" data-tooltip={action.tooltip} onClick={action.onClick}>
						{action.icon != null ?
							<Icon name={action.icon} />
							: null}
					</Link>
				);

			default:
				return null;
		}
	}

	render() {
		const activeSchool = this.props.user.schools != null && this.props.user.schools.length > 0 ?
			this.props.user.schools.find((school) =>
				school.id == getActiveSchool(this.props.user.id))
			: null;

		return (
			<div>
				<div className="teams-header">
					<div className="content">
						{this.props.settings.backButton ?
							<Link to="#" onClick={this.goBack} className="c--button back">
								<i className="cl-container">
									<svg xmlns="http://www.w3.org/2000/svg" style={{ transform: 'rotate(90deg)' }} className="a-90">
										<path
											id="Path_50"
											data-name="Path 50"
											className="cls-1"
											d="M11.361,1.4,6.38,5.9,1.4,1.4"
										/>
									</svg>
								</i>
							</Link>
							: null}

						{this.props.title != null ?
							<div className="page-title" title={this.props.title}>
								{activeSchool != null ?
									activeSchool.title + ' / '
									: null}

								{this.props.title}
							</div>
							: null}
					</div>

					<div className="content right">
						<div className="actions" id="teams-header-actions">
							{this.props.settings.actions != null ?
								this.props.settings.actions.map(this.renderAction)
								: null}
						</div>
					</div>
				</div>
			</div>
		);
	}

}

function mapStateToProps(state) {
	return {
		user: state.user.currentUser,
		title: state.Header.title,
		settings: state.Header,
	};
}

export default withRouter(connect(mapStateToProps, {
	onRouteBack,
})(Header));